import axios from "axios"

// Custom Component
import SignOut from '../components/SignIn/SignOut'

const store = require('store')


const getCoverType = async () => {
	const getCoverType_api = '/drawing/attr/cover/type'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getCoverType_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getPurposeType = async () => {
	const getPurposeType_api = '/drawing/attr/purpose/type'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getPurposeType_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getDrawingTypeAndGroup = async () => {
	const getDrawingTypeAndGroup_api = '/drawing/attr/type/group'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getDrawingTypeAndGroup_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



const getRelatedItemType = async () => {
	const getRelatedItemType_api = '/drawing/attr/relative/type/group'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getRelatedItemType_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}

const getRelatedItemAllType = async () => {
	const getRelatedItemType_api = '/drawing/attr/relative/type'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getRelatedItemType_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



const getCompanyList = async () => {
	const companyList_api = '/company'
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3001 + companyList_api,
			headers: headers,
		})

		return result.data.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getLatestDrawing = async () => {
	const getLatestDrawing_api = "/drawing"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getLatestDrawing_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getDrawingDetail = async (drawingSeq) => {
	const getDrawingDetail_api = `/drawing/${drawingSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getDrawingDetail_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getCover = async () => {
	const getCover_api = "/drawing/cover"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getCover_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getCoverDetail = async (coverSeq) => {
	const getCoverDetail_api = `/drawing/cover/${coverSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getCoverDetail_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



const getRelatedItems = async (drawingSeq, revisionSeq) => {
	const getRelatedItems_api = `/drawing/${drawingSeq}/${revisionSeq}/relative`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getRelatedItems_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getRelatedItemsDetail = async (drawingSeq, revisionSeq, relativeSeq) => {
	const getRelatedItemsDetail_api = `/drawing/${drawingSeq}/${revisionSeq}/${relativeSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getRelatedItemsDetail_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



const createUnpublish = async (requestBodyData) => {
	const createUnpublish_api = "/drawing/unpublish"
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3009 + createUnpublish_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getUnpublishPacks = async () => {
	const getUnpublishPacks_api = "/drawing/unpublish"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getUnpublishPacks_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getUnpublishDetail = async (unpublishSeq) => {
	const getUnpublishDetail_api = `/drawing/unpublish/${unpublishSeq}`
	let headers
	let result

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + getUnpublishDetail_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const saveUnpublish = async (unpublishSeq, requestBodyData) => {
	const saveUnpublish_api = `/drawing/unpublish/${unpublishSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'put',
			url: process.env.REACT_APP_API_URL_3009 + saveUnpublish_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const publishDrawing = async (unpublishSeq, requestBodyData) => {
	const publishDrawing_api = `/drawing/unpublish/${unpublishSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3009 + publishDrawing_api,
			headers: headers,
			data: requestBodyData
		})

		console.log("***** Publish Drawing : ", result)

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const createRelatedItem = async (drawingSeq, revisionSeq, requestBodyData) => {
	const createRelatedItem_api = `/drawing/${drawingSeq}/${revisionSeq}/relative`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3009 + createRelatedItem_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const updateDrawingRevision = async (drawingSeq, revisionSeq, requestBodyData) => {
	const updateDrawingRevision_api = `/drawing/${drawingSeq}/${revisionSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3009 + updateDrawingRevision_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const updateRelatedItem = async (drawingSeq, revisionSeq, relativeSeq, requestBodyData) => {
	const updateRelatedItem_api = `/drawing/${drawingSeq}/${revisionSeq}/${relativeSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3009 + updateRelatedItem_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const updateCover = async (coverSeq, requestBodyData) => {
	const updateCover_api = `/drawing/cover/${coverSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3009 + updateCover_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const updateDrawing = async (dwgSeq, requestBodyData) => {
	const updateDrawing_api = `/drawing/${dwgSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3009 + updateDrawing_api,
			headers: headers,
			data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const deleteUnpublish = async unpublishSeq => {
	const deleteUnpublish_api = `/drawing/unpublish/${unpublishSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3009 + deleteUnpublish_api,
			headers: headers,
			// data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



const deleteDrawing = async dwgSeq => {
	const deleteDrawing_api = `/drawing/${dwgSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3009 + deleteDrawing_api,
			headers: headers,
			// data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const deleteCover = async coverSeq => {
	const deleteCover_api = `/drawing/cover/${coverSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3009 + deleteCover_api,
			headers: headers,
			// data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const deleteRevision = async (dwgSeq, revisionSeq) => {
	const deleteRevision_api = `/drawing/${dwgSeq}/${revisionSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3009 + deleteRevision_api,
			headers: headers,
			// data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const deleteRelativeItem = async (dwgSeq, revisionSeq, relativeSeq) => {
	const deleteRelativeItem_api = `/drawing/${dwgSeq}/${revisionSeq}/${relativeSeq}`
	let headers
	// let params = new URLSearchParams()
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		// params.append(requestBodyData)

		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3009 + deleteRelativeItem_api,
			headers: headers,
			// data: requestBodyData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const downloadLatestDrawing = async (dwgSeq, fullset) => {
	const downloadLatestDrawing_api = "/drawing/download"
	let headers
	let queryParams

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		queryParams = dwgSeq.join('&dwg_seq=')

		// axios({
		// 	method: 'get',
		// 	url: process.env.REACT_APP_API_URL_3009 + downloadLatestDrawing_api + "?dwg_seq=" + queryParams + "&fullset=" + fullset,
		// 	headers: headers,
		// 	responseType: 'blob',
		// }).then(response => {
		// 	console.log(response)
		// 	const blob = new Blob([response.data], {type: response.data.type})
		// 	const downloadUrl = window.URL.createObjectURL(blob)
		// 	const link = document.createElement('a')
		// 	link.href = downloadUrl
		// 	const header_filename = response.headers['download-filename']
		// 	let filename = 'date_time'
		// 	if (header_filename) {
		// 		filename = header_filename
		// 	}
		// 	link.setAttribute('download', filename)
		// 	document.body.appendChild(link)
		// 	link.click()
		// 	link.remove()
		// })

		const response = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + downloadLatestDrawing_api + "?dwg_seq=" + queryParams + "&fullset=" + fullset,
			headers: headers,
			responseType: 'blob',
		})
	
		const blob = new Blob([response.data], {type: response.data.type})
		const downloadUrl = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = downloadUrl
		const header_filename = response.headers['download-filename']
		let filename = 'date_time'
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute('download', filename)
		document.body.appendChild(link)
		link.click()
		link.remove()
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const downloadCover = async (coverSeq, fullset) => {
	const downloadCover_api = "/drawing/cover/download"
	let headers
	let queryParams

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		queryParams = coverSeq.join('&cover_seq=')

		// axios({
		// 	method: 'get',
		// 	url: process.env.REACT_APP_API_URL_3009 + downloadCover_api + "?cover_seq=" + queryParams + "&fullset=" + fullset,
		// 	headers: headers,
		// 	responseType: 'blob',
		// }).then(response => {
		// 	console.log(response)
		// 	const blob = new Blob([response.data], {type: response.data.type})
		// 	const downloadUrl = window.URL.createObjectURL(blob)
		// 	const link = document.createElement('a')
		// 	link.href = downloadUrl
		// 	const header_filename = response.headers['download-filename']
		// 	let filename = 'date_time'
		// 	if (header_filename) {
		// 		filename = header_filename
		// 	}
		// 	link.setAttribute('download', filename)
		// 	document.body.appendChild(link)
		// 	link.click()
		// 	link.remove()
		// })

		const response = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + downloadCover_api + "?cover_seq=" + queryParams + "&fullset=" + fullset,
			headers: headers,
			responseType: 'blob',
		})

		const blob = new Blob([response.data], {type: response.data.type})
		const downloadUrl = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = downloadUrl
		const header_filename = response.headers['download-filename']
		let filename = 'date_time'
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute('download', filename)
		document.body.appendChild(link)
		link.click()
		link.remove()
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const downloadRevision = async (dwgSeq, revisionSeq, fullset) => {
	const downloadRevision_api = `/drawing/${dwgSeq}/revision/download`
	let headers
	let queryParams

	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		queryParams = revisionSeq.join('&rev_seq=')

		// axios({
		// 	method: 'get',
		// 	url: process.env.REACT_APP_API_URL_3009 + downloadRevision_api + "?rev_seq=" + queryParams + "&fullset=" + fullset,
		// 	headers: headers,
		// 	responseType: 'blob',
		// }).then(response => {
		// 	console.log(response)
		// 	const blob = new Blob([response.data], {type: response.data.type})
		// 	const downloadUrl = window.URL.createObjectURL(blob)
		// 	const link = document.createElement('a')
		// 	link.href = downloadUrl
		// 	const header_filename = response.headers['download-filename']
		// 	let filename = 'date_time'
		// 	if (header_filename) {
		// 		filename = header_filename
		// 	}
		// 	link.setAttribute('download', filename)
		// 	document.body.appendChild(link)
		// 	link.click()
		// 	link.remove()
		// })


		const response = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3009 + downloadRevision_api + "?rev_seq=" + queryParams + "&fullset=" + fullset,
			headers: headers,
			responseType: 'blob',
		})
		
		const blob = new Blob([response.data], {type: response.data.type})
		const downloadUrl = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = downloadUrl
		const header_filename = response.headers['download-filename']
		let filename = 'date_time'
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute("download",filename);
		document.body.appendChild(link)
		link.click()
		link.remove()
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}



export {
	getCoverType,
	getPurposeType,
	getDrawingTypeAndGroup,
	getRelatedItemType,
	getRelatedItemAllType,
	getCompanyList,
	getLatestDrawing,
	getDrawingDetail,
	getCover,
	getCoverDetail,
	getRelatedItems,
	getRelatedItemsDetail,
	createUnpublish,
	getUnpublishPacks,
	getUnpublishDetail,
	saveUnpublish,
	publishDrawing,
	createRelatedItem,
	updateDrawingRevision,
	updateRelatedItem,
	updateCover,
	updateDrawing,
	
	deleteUnpublish,
	deleteDrawing,
	deleteCover,
	deleteRevision,
	deleteRelativeItem,

	downloadLatestDrawing,
	downloadCover,
	downloadRevision
}